import { DoctorField } from './doctor-model';
import {
  StatoFatturaSDI,
  StatoFatturaSTS,
  TableInvoiceFields,
} from './invoices';
import {
  DiagnosisTableRow,
  Document,
  FamilyHistoryField,
  Interview,
  InterviewNotes,
  MedicalHistoryField,
  PatientDocument,
  PatientWithNextInterview,
  PharmacoterapyTableRow,
  Reminders,
  SignificantEvent,
} from './patient-model';

export const mockedNotes: string[] = [
  'Questa è una prima nota di prova.',
  'Questa è ancora una nota di prova, ma più lunga acciderbolina.',
  'Terza nota',
  'Quarta nota',
  'Quinta nota',
];

export const mockedReminders: Reminders[] = [
  { text: 'Primo promemoria', completed: false },
  { text: 'Secondo promemoria', completed: true },
  { text: 'Terzo promemoria', completed: false },
];

export const mockedInterviews: Interview[] = [
  { date: '21/02/2024', title: 'Appuntamento del 21/02/2024' },
  { date: '14/01/2024', title: 'Problemi matrimoniali' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
  { date: '13/12/2023', title: 'Appuntamento del 13/12/2023' },
];

export const mockedInterviewNotes: InterviewNotes[] = [
  { categoria: 'Umore', valori: ['basso'], descrizione: '' },
  {
    categoria: 'Eventi significativi',
    valori: [
      'evento 1',
      'evento 2',
      'evento 3',
      'evento 4',
      'evento 1',
      'evento 2',
    ],
    descrizione: 'Evento increbibile',
  },
  {
    categoria: 'Topic importanti',
    valori: ['topic 1', 'topic 2'],
    descrizione: 'Topic abbastanza interessante',
  },
  {
    categoria: 'Sintomi e segni',
    valori: ['sintomo 1', 'segni 2'],
    descrizione: 'Sintomo davvero inusuale, segno più tranquillo',
  },
  { categoria: 'Altro', valori: [], descrizione: 'Non ho altro da aggiungere' },
];

export const mockedPersonalMedicalHistory: MedicalHistoryField[] = [
  { label: 'Anni di istruzione', description: '18' },
  { label: 'Occupazione', description: 'Motociclista moto GP' },
  { label: 'Stato civile', description: 'Celibe' },
  { label: 'Figli, quanti?', description: 'Nessuno' },
  { label: 'Affettività', description: '' },
  { label: 'Hobby', description: 'Sport estremi' },
  { label: 'Sport', description: 'Hobby equilibrati' },
  { label: 'Supporti', description: 'Badante' },
];

export const mockedMedicalMedicalHistory: MedicalHistoryField[] = [
  { label: 'Percorsi clinici pregressi', description: '' },
  { label: 'Ricoveri e interventi chirurgici', description: '' },
  { label: 'Anamnesi farmacologica', description: '' },
  { label: 'Patologie', description: '' },
  { label: 'Sostanze', description: 'Nah' },
];

// Doctor mocked attributes

export const mockedDoctorPersonalFields: DoctorField[] = [
  { label: 'Nome', description: 'John' },
  { label: 'Cognome', description: 'Doe' },
  { label: 'Email', description: 'john.doe@example.com' },
  { label: 'Data di nascita', description: '1980-01-01' },
  { label: 'Luogo di nascita', description: 'City' },
  { label: 'Codice fiscale', description: 'ABC123DEF456GHI7' },
];

export const mockedDoctorResidenceFields: DoctorField[] = [
  { label: 'Indirizzo di residenza', description: 'Street ABC' },
  { label: 'Numero civico', description: '123' },
  { label: 'Città', description: 'City XYZ' },
  { label: 'Provincia', description: 'Province' },
  { label: 'CAP', description: '12345' },
  { label: 'Indirizzo fiscale coincide con la residenza', description: 'Sì' },
  { label: 'Indirizzo fiscale', description: 'Tax Street' },
  { label: 'Numero civico fiscale', description: '456' },
  { label: 'Città fiscale', description: 'Tax City' },
  { label: 'Provincia fiscale', description: 'Tax Province' },
  { label: 'CAP fiscale', description: '54321' },
];

export const mockedDoctorFinancialFields: DoctorField[] = [
  { label: 'IBAN', description: 'IT60X0123456789012345678901' },
  { label: 'Partita IVA', description: '12345678901' },
  { label: 'Ragione sociale', description: 'Business XYZ' },
  { label: 'Posta certificata', description: 'certified.xyz@example.com' },
  { label: 'Codice identificativo univoco', description: '123456' },
  { label: 'Email consulente finanziario', description: 'advisor@example.com' },
];

// ----------------------- Patient's mocked data -------------------------

export const mockedDiagnosisTable: DiagnosisTableRow[] = [
  {
    codex: 'F50.81',
    description: 'Disturbo da binge-eating',
    date: '15/03/2022',
    note: 'Questo campo mi serve per aggiungere dei dettagli a mio piacimento in merito a questo particolare disturbo. ',
  },
  {
    codex: 'F50.81',
    description: 'Disturbo da binge-eating',
    date: '15/03/2022',
    note: 'Boh ',
  },
  {
    codex: 'F50.81',
    description: 'Disturbo da binge-eating',
    date: '15/03/2022',
    note: '',
  },
  {
    codex: 'F50.81',
    description: 'Disturbo da binge-eating',
    date: '15/03/2022',
    note: 'Questo campo mi serve per aggiungere dei dettagli a mio piacimento in merito a questo particolare disturbo. ',
  },
  {
    codex: 'F50.81',
    description: 'Disturbo da binge-eating',
    date: '15/03/2022',
    note: 'Questo campo mi serve per aggiungere dei dettagli a mio piacimento in merito a questo particolare disturbo. ',
  },
];

export const mockedPharmacoterapyTable: PharmacoterapyTableRow[] = [
  {
    activePrinciple: ['Clazapina'],
    description: 'Da prendere due volte al giorno',
  },
  {
    activePrinciple: ['Clazapina', 'Aloperidolo'],
    description: '2ml al giorno, 5ml al giorno, 3 volte ogni 8 ore',
  },
];

export const mockedDocuments: Document[] = [
  { category: 'Burocrazia', title: 'Codice Deontologico v1' },
  { category: 'Burocrazia', title: 'Codice Deontologico v2' },
  { category: 'Burocrazia', title: 'Consenso Informato' },
  { category: 'Didattica', title: 'Lezione su Freud' },
  { category: 'Didattica', title: 'Lezione su Jung' },
  { category: 'Documenti Personali', title: 'Template domande per paziente' },
  { category: 'Documenti Personali', title: 'Appunti su qualcosa' },
  { category: 'Documenti Personali', title: 'Contatti Conferenza Torino' },
  { category: 'Documenti Personali', title: "Scan carta d'identità" },
];

export const mockedHumorList: string[] = ['Alto', 'Basso', 'Normale'];

export const mockedSignificantEventsList: string[] = [
  'Evento 1',
  'Evento 2',
  'Evento 3',
];

export const mockedImportantTopicList: string[] = [
  'Topic 1',
  'Topic 2',
  'Topic importantissimo',
];

export const mockedSymptomsSignsList: string[] = [
  'Sintomo 1',
  'Segni 2',
  'Sintomi e segni 3',
];

export const mockedSignificantEvents: SignificantEvent[] = [
  { date: '05/2021', title: 'Matrimonio Peppino' },
  { date: '07/2021', title: 'Divorzio Peppino' },
  { date: '09/1980', title: 'Nascita Peppino' },
  { date: '12/2022', title: 'Morte Peppino' },
  { date: '05/2021', title: 'Matrimonio Peppino' },
  { date: '07/2021', title: 'Divorzio Peppino' },
  { date: '09/1980', title: 'Nascita Peppino' },
  { date: '12/2022', title: 'Morte Peppino' },
  { date: '05/2021', title: 'Matrimonio Peppino' },
  { date: '07/2021', title: 'Divorzio Peppino' },
  { date: '09/1980', title: 'Nascita Peppino' },
  { date: '12/2022', title: 'Morte Peppino' },
  { date: '05/2021', title: 'Matrimonio Peppino' },
  { date: '07/2021', title: 'Divorzio Peppino' },
  { date: '09/1980', title: 'Nascita Peppino' },
  { date: '12/2022', title: 'Morte Peppino' },
  { date: '05/2021', title: 'Matrimonio Peppino' },
  { date: '07/2021', title: 'Divorzio Peppino' },
  { date: '09/1980', title: 'Nascita Peppino' },
  { date: '12/2022', title: 'Morte Peppino' },
  { date: '05/2021', title: 'Matrimonio Peppino' },
  { date: '07/2021', title: 'Divorzio Peppino' },
  { date: '09/1980', title: 'Nascita Peppino' },
  { date: '12/2022', title: 'Morte Peppino' },
];
